import type { PropsWithChildren } from 'react';
import Slider from 'react-slick';
import { cn, PaletteUtils } from '@shared/utils';
import './carousel.scss';

export const Carousel = (props: PropsWithChildren) => {
  return (
    <Slider
      className='overflow-visible'
      dots
      dotsClass={cn('button__bar', PaletteUtils.isVcfcPalette && 'vcfc', PaletteUtils.isPersonalPalette && 'personal')}
      infinite={false}
      speed={500}
      slidesToShow={1}
      slidesToScroll={1}
      arrows={false}
    >
      {props.children}
    </Slider>
  );
};
